exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn--primary[data-v-fd8c1192] {\n  background-color: #F08B71;\n  color: #FFFFFF;\n}\n.btn--primary a[data-v-fd8c1192] {\n    color: #FFFFFF;\n}\n", ""]);
